import { v4 } from "uuid";
import { cn } from "~/lib/utils";
import Image from "~/components/atoms/Image";

interface Item {
    title: string;
    content?: string | null;
}

export interface Props {
    asset?: {
        path: string;
        alt: string;
        lazyLoad?: boolean;
    };
    items: Item[];
}

function Column({ title, content, className }: Item & { className?: string }) {
    return (
        <div
            className={cn(
                "flex min-w-min flex-col items-center justify-center gap-2 border-blue-20 px-4 last:!border-0 sm:border-r",
                className,
            )}
        >
            <h6 className="font-subheader-2 text-center uppercase text-blue-80 sm:max-w-fit">
                {title}
            </h6>
            <span className="font-subheader-2 sm:font-header-xs w-max text-gray-80">{content}</span>
        </div>
    );
}

export function StatisticsBox(props: Props) {
    const { asset } = props;
    const items = props.items.filter(
        i => i.content !== null && i.content !== undefined && i.content.length > 0,
    );
    if (items.length < 1) return null;
    const exceedsMaxColumns = items.length > 3;
    const cols = exceedsMaxColumns ? "grid-cols-[repeat(2,1fr)]" : "grid-flow-col";
    const border = exceedsMaxColumns ? "odd:border-r" : "border-r";
    return (
        <div className="mt-4 flex w-full flex-col items-center self-center rounded-md border border-blue-80">
            {asset ? (
                <Image
                    loading={asset.lazyLoad ? "lazy" : "eager"}
                    alt={asset.alt}
                    src={asset.path}
                    className="relative top-[-16px] w-12 bg-white px-2"
                />
            ) : (
                <div className="h-8" />
            )}
            <div className={cn("grid gap-y-4 pb-8 sm:auto-cols-fr sm:grid-flow-col", cols)}>
                {items.map(i => (
                    <Column key={v4()} {...i} className={border} />
                ))}
            </div>
        </div>
    );
}
